import axios from "axios";
import moment from "moment";

const ClassSessionService = {
  dateCheck(sessionDate, classStartDate, classEndDate) {
    if (!sessionDate || !classStartDate || !classEndDate) {
      return { date_invalid_error: false };
    }

    const session = moment(sessionDate, "YYYY-MM-DD", true);
    const start = moment(classStartDate, "YYYY-MM-DD", true);
    const end = moment(classEndDate, "YYYY-MM-DD", true);

    const date_invalid_error = !session.isValid() || session.isBefore(start) || session.isAfter(end);

    return { date_invalid_error };
  },

  timeCheck(startTime, endTime) {
    const start = moment(startTime, "HH:mm");
    const end = moment(endTime, "HH:mm");

    const time_invalid_error = end.isBefore(start);
    const time_equal_error = end.isSame(start);

    return { time_invalid_error, time_equal_error };
  },

  async getClassInfo(classId) {
    try {
      const res = await axios.get(`class/info/${classId}`);
      return {
        start_date: res.data.start_date,
        end_date: res.data.end_date,
      };
    } catch (err) {
      console.error(err);
      return null;
    }
  },
};

export default ClassSessionService;
